import { useSession } from "@src/appV2/Auth/api/useSession";
import { Text } from "@src/lib/ui-react";
import { useLocation } from "react-router-dom";

import { ExploEmbed } from "./ExploEmbed";

export function AnalyticsDashboard() {
  const {
    profile: { userId: workplaceId, tmz },
  } = useSession();
  const location = useLocation();
  const embedId = new URLSearchParams(location.search).get("embedId") ?? "";

  if (!embedId || !workplaceId) {
    return <Text variant="h2">Analytics dashboard is not configured for this workplace.</Text>;
  }

  return <ExploEmbed workplaceId={workplaceId} embedId={embedId} tmz={tmz} />;
}

export default AnalyticsDashboard;
